import { deleteRequest, post } from 'helpers/api';

export const ADD_DEFAULT_REMINDER = 'ADD_DEFAULT_REMINDER';
export function addDefaultReminder(reminder) {
  return async (dispatch, getState) => {
    const savedReminder = await post(getState().path, reminder);
    dispatch({
      type: ADD_DEFAULT_REMINDER,
      reminder: savedReminder,
    });
  };
}

export const DELETE_DEFAULT_REMINDER = 'DELETE_DEFAULT_REMINDER';
export function deleteDefaultReminder(reminder) {
  return async (dispatch) => {
    await deleteRequest(reminder.path);
    dispatch({
      type: DELETE_DEFAULT_REMINDER,
      reminder,
    });
  };
}
